import { Component, ElementRef, EventEmitter, HostBinding, Inject, Injector, Input, NgZone, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { CommonUtils } from "@farris/ui-common";
import { SnapSelectMode,  SnapUtils,SnapSize,SNAP, SnapClickEventInfo} from './modal-options.class';
import { Subject } from 'rxjs';


@Component({
    selector: 'modal-position-snap',
    templateUrl: './modal-position-snap.component.html'
})
export class ModalPositionSnapComponent implements OnInit,OnDestroy {
    @HostBinding("class.modal-position-snap-wrapper") cls=true;
    @ViewChild("snapDropdown") snapDropdown:ElementRef;
    @ViewChild("snapDropMenu") snapDropMenu:ElementRef;
    /**默认类型 */
    @Input() snaps:Array<SNAP>= SnapUtils.getSnapTypes();
    //默认类型 形如 
    curSnap='';
    curSnapChild='';
    // 初始是空
    private _defaultType='';
    // 是否禁用
    @Input() disabled=false;
    @Input() 
    set defaultType(val:string){
        if(val){
            if(this._defaultType!=val){
                this.verifyDefaultType(val);   
            }
        }else if(this._defaultType!=val){
            //传递的是空值并且之前默认类型有值
            this.clearSnap(null);
        }
    };
    // 拆分
    @Input() snapDPSplit=false;
    // 文本
    @Input() snapDPtext='';
    // 样式
    @Input() snapBtnCls='';
    // 清空文本
    @Input() snapClearText='';
    /**
     * Item样式
     */
    @Input() snapItemCls='';
    // 尺寸 large middle small 
    @Input() size = SnapSize.large;
    // 选择方式 single|whole
    @Input() selectMode=SnapSelectMode.single;
    // 当前Snap的显示装填
    showSnapMenu = false;
    // 计算出来visibility的状态
    computeSnapMenuDP = false;
    SNAP_TYPE = [];
    // 计算容器
    computedWraper=null;
    private commonUtils;
    // 记录鼠标进入按钮之后的时间
    setTimeOutTimer: any;
    private dpMenuStateChanges=new Subject();
    /* 事件 */
    mouseenterEvent: any;
    mouseleaveEvent: any;
    // 点击
    @Output() snapClickEvent= new EventEmitter<SnapClickEventInfo>();
    // 清空
    @Output() snapClearEvent= new EventEmitter<SnapClickEventInfo>();
    // 默认类型
    @Output() snapDefaultEvent= new EventEmitter<SnapClickEventInfo>();
    // 只有在snapDPSplit为true的时候，才有此事件
    @Output() snapTextClickEvent=new EventEmitter<SnapClickEventInfo>();

    constructor(private ele: ElementRef, private render: Renderer2,private ngZone:NgZone, private inject: Injector) {
        this.commonUtils = new CommonUtils();
    }
    /**
     * 验证默认的类型
     * @param type 
     */
    private verifyDefaultType(type){
        let tVal=type.split("_");
        // 提供的分类要在现有分类中能找到
        let wholeSnap=this.snaps.find(item=>item.type==tVal[0]);
        if(!wholeSnap){return;}
        // 如果是整体
        this.snapClick(null,wholeSnap.type,true);
        // 如果是单个
        if(tVal.length==2&&wholeSnap.children.find(item=>item.type==type)){
            this.snapChildClick(null,type,true)
        }
    }

    ngOnInit(): void {
        this.dpMenuStateChanges.subscribe((dpMenuState:boolean)=>{
            if(dpMenuState==this.showSnapMenu){
                return;
            }
            this.showSnapMenu=dpMenuState;
            if(dpMenuState){
                this.computeSnapMenuDP=false;
                let dpMenuCls= this.snapDropMenu.nativeElement.className.replace(/ show/ig,'');
                this.snapDropMenu.nativeElement.className=dpMenuCls+' show';  
                // 展开
                this.ngZone.runOutsideAngular(() => {
                    setTimeout(()=>{
                        this.setMenuPanelPosition();
                        this.computeSnapMenuDP=true;                       
                        // 为面板绑定事件
                        this.bindMenuEvent();
                        // 展开下拉，但是没有进入，等待间隔后，下拉面板消失
                        this.mouseleaveHandler();
                    },0);
                });              
            }else{
                // 消失     
                this.computeSnapMenuDP=false;     
                let dpMenuCls= this.snapDropMenu.nativeElement.className.replace(/ show/ig,'');
                this.snapDropMenu.nativeElement.className=dpMenuCls;
                this.snapDropdown.nativeElement.parentElement.append(this.snapDropMenu.nativeElement);
                this.unBindMenuEvent();
            }
        });
    }
    ngOnDestroy(): void {
        if (this.setTimeOutTimer) {
            clearTimeout(this.setTimeOutTimer);
        }
        
        if(this.dpMenuStateChanges){
            this.dpMenuStateChanges.unsubscribe();
            this.dpMenuStateChanges=null;
        }
        if(this.snapDropdown.nativeElement&&!this.snapDropdown.nativeElement.nextElementSibling){
            this.snapDropdown.nativeElement.parentElement.append(this.snapDropMenu.nativeElement);
        }
    }
    /**
     * 鼠标进入menu清空timeout
     */
    private mouseenterHandler(){
        if (this.setTimeOutTimer) {
            clearTimeout(this.setTimeOutTimer);
        }
    }
    /**
     * 鼠标没有进入到面板或者鼠标从面板离开后，
     *  一段时间后面板自动消失 
     */
    private mouseleaveHandler(){
        this.ngZone.runOutsideAngular(() => {
			if (this.setTimeOutTimer) {
				clearTimeout(this.setTimeOutTimer);
			}
            this.setTimeOutTimer = setTimeout(() => {
                    // 关闭
                    this.dpMenuStateChanges.next(false);
                    // if (this.setTimeOutTimer) {
                    //     clearTimeout(this.setTimeOutTimer);
                    // }
            }, 2000);
        });
    }
    /**
     * 为下拉面板绑定事件
     * @param type 
     */
    private bindMenuEvent() {
        this.unBindMenuEvent();
        ['mouseenter','mouseleave'].map((type)=>{
            this[type+'Event'] = this[type+'Handler'].bind(this);
            // 绑定鼠标进入事件
            this.snapDropMenu.nativeElement.addEventListener(
                type,
                this[type+'Event']
            );
        })        
    }
     /*  
     *  为下拉面板解绑事件
     */
    private unBindMenuEvent() {
        ['mouseenter','mouseleave'].map((type)=>{
            if (this[type+'Event']) {
                this.snapDropMenu.nativeElement.removeEventListener(type,this[type+'Event']);
            }
        });
    }
    /**
     * 清空已选的Snap
     * @param ev 
     */
    clearSnap(ev){
        ev&&ev.stopPropagation();
        ev&&ev.preventDefault();
        if(this.disabled) return;
        this.resetCurSnap();
        this.snapClearEvent.emit({selectMode:this.selectMode,snapType:'',snapInfo:null});
    }
    /**
     * 重置当前
     */
    private resetCurSnap(){
        this.curSnap='';
        this.curSnapChild='';
    }
    /**
     * 点击Snap下拉按钮
     * @param ev 
     */
    snapBtnClick(ev:MouseEvent){
        ev&&ev.stopPropagation();
        if(this.disabled) return;
        if(this.showSnapMenu){
            // 如果当前是显示，则关闭
            this.dpMenuStateChanges.next(false);
        }else{
            this.dpMenuStateChanges.next(true);
        }
    }
    mousedownEvent(ev:MouseEvent){
        ev&&ev.stopPropagation();
    }
    /**
     * 缩略图父级点击
     */
    snapClick(ev:MouseEvent,snapItemType:string,isDefault=false,fromTextBtn=false){
        if(!this.disabled&&this.selectMode==SnapSelectMode.whole){    
            ev&&ev.stopPropagation();        
            let info= SnapUtils.findSnapType(this.snaps,this.selectMode,snapItemType);
            this.curSnap=snapItemType;
            this.curSnapChild='';
            let eventName=isDefault?'snapDefaultEvent':(fromTextBtn?'snapTextClickEvent':'snapClickEvent');
            this[eventName].emit({selectMode:this.selectMode,snapType:snapItemType,snapInfo:info});
            this.dpMenuStateChanges.next(false);
        }
        
    }
    /**
     * 缩略图子项点击
     * @param ev 
     * @param snapItem 
     * @param snapChildItem 
     */
    snapChildClick(ev:MouseEvent,snapChildItemType:string,isDefault=false,fromTextBtn=false){ 
        if(!this.disabled&&this.selectMode==SnapSelectMode.single){ 
            ev&&ev.stopPropagation();       
            let info= SnapUtils.findSnapType(this.snaps,this.selectMode,snapChildItemType);
            this.curSnap='';
            this.curSnapChild=snapChildItemType;
            let eventName=isDefault?'snapDefaultEvent':(fromTextBtn?'snapTextClickEvent':'snapClickEvent');
            this[eventName].emit({selectMode:this.selectMode,snapType:snapChildItemType,snapInfo:info,});
            //this.showSnapMenu=false;
            this.dpMenuStateChanges.next(false);
        }
    }
    /**
     * 点击预览的文字
     * @param ev 
     * @returns 
     */
    snapPreviewTextClick(ev:MouseEvent){
        ev&&ev.stopImmediatePropagation();
        if(this.disabled){return;}
        if(this.selectMode==SnapSelectMode.whole){
            if(this.curSnap){
                this.snapClick(ev,this.curSnap,false,true);
            }else{
                this.snapTextClickEvent.emit({selectMode:this.selectMode,snapType:'',snapInfo:[]});  
            }
        }else{
            if(this.curSnapChild){
                this.snapChildClick(ev,this.curSnapChild,false,true);
            }else{
                this.snapTextClickEvent.emit({selectMode:this.selectMode,snapType:'',snapInfo:{width:1,height:1,left:0,top:0,right:-1,bottom:-1}});  
            } 
        }
    }
    /**
     * 因为按钮的位置可能会随着窗口变动，此处就当展开时随时计算
     * 计算按钮展开位置
     */
    private setMenuPanelPosition() {
        const { height, left, top, width } = this.snapDropdown.nativeElement.getBoundingClientRect();
        const{marginTop:menuMt,marginBottom:menuMb}=getComputedStyle(this.snapDropMenu.nativeElement);
        const { width: pw, height: ph } = this.snapDropMenu.nativeElement.getBoundingClientRect();
        let _maxHeight=0;
        let tMenuMargin= Math.ceil(parseFloat(menuMt))+ Math.ceil(parseFloat(menuMb));
        let _top = top + height;
        let _left = left;
        if (window.innerHeight - top - height - tMenuMargin < ph) {
            _top = top - ph;
            if(_top<0){
                //当前的界面容不下menu上的按钮，限制menu的高度
                _top=10;
                _maxHeight=top-_top-tMenuMargin;
            }
        }
        if (window.innerWidth - left - width < pw) {
            _left = left - pw + width;
        } 
        document.body.append(this.snapDropMenu.nativeElement);
        this.snapDropMenu.nativeElement.style.cssText = `position:fixed;left:${_left}px !important;top:${_top}px !important;max-height:${_maxHeight?_maxHeight+'px;overflow:auto':'none'}`;
        this.snapDropMenu.nativeElement.style.zIndex = this.commonUtils.getFloatingLayerIndex();
    }
}
